module.exports = __webpack_public_path__ + "static/media/close_transpaent.446cd371.svg";